import { getCookie, isEmpty, pageLoadTime } from 'utils/browserHelper'
import Clevertap from 'analytics'
import { dayDiff, getFormattedDate } from 'utils/dateHelper'
import { dataLayerGA } from 'utils/dataLayerHelper.js'
import { formSrpSearchQuery } from 'utils/flights/results'

export const getSearchUrlParams = () => {
    const searchUrl = window.location.search || ''
    let params = searchUrl
    if (searchUrl.indexOf('?') > -1) {
        params = searchUrl.slice(1)
    }

    const urlParam = formSrpSearchQuery(params)
    return urlParam
}

export const clevertapPageLoad = ({
    getItinearyData,
    signedIn,
    clevertapData,
    initialTS,
    pageName,
    lastPageName,
    eventName,
    tk_home_abcookie,
    tk_itin_abcookie,
    ...additionpayload
}) => {
    const airline = []
    const flightNumbers = []
    const airlineNames = []
    const flights = getItinearyData.flights
    const { searchCriteria, itineraryId, currencyConversionFactor = {}, meta = {} } = getItinearyData
    const { paxInfo: { adults, children, infants } = {}, departDate, arrivalDate, international, from, to, multiCity } =
        searchCriteria || {}
    if (!isEmpty(flights)) {
        flights.forEach(flight =>
            flight.segments.forEach(segment => {
                airline.push(segment.airline)
                flightNumbers.push(segment.flightNumber)
                airlineNames.push(segment.airlineName)
            })
        )
        let rt = false
        let airlineValue = airline[0]
        if (airline.length > 1) {
            rt = true
            airlineValue = airline[0] + ',' + airline[1]
        }
        let flightNumbersValue = flightNumbers.length > 1 ? flightNumbers.join(',') : flightNumbers[0]
        let airlineNameValue = airlineNames.length > 1 ? airlineNames.join(',') : airlineNames[0]
        const urlParam = getSearchUrlParams()
        let clevertapAirPayload = {
            page_name: pageName,
            last_page_name: lastPageName,
            origin: from,
            destination: to,
            airline: airlineValue,
            airlineName: airlineNameValue,
            flightNumber: flightNumbersValue,
            Channel: 'CT',
            itineraryId,
            dx: dayDiff(new Date(departDate), new Date()),
            journey_type: multiCity ? 'MultiCity' : arrivalDate ? 'RoundTrip' : 'OneWay',
            dom_intl: international ? 'international' : 'Domestic',
            adult_count: adults,
            child_count: children,
            infant_count: infants,
            departure_date: getFormattedDate(departDate, 'DD/MM/YYYY', 'YYYY-MM-DDTHH:mm:ssZ'),
            return_date: arrivalDate ? getFormattedDate(arrivalDate, 'DD/MM/YYYY', 'YYYY-MM-DDTHH:mm:ssZ') : 'NA',
            stay_duration: arrivalDate ? dayDiff(new Date(arrivalDate), new Date(departDate)) : 'NA',
            domain: window.location.host,
            source: 'web',
            language: window.location.href.includes('/ar/') ? 'ar' : 'en',
            is_logged_in: signedIn ? 'yes' : 'no',
            user_pref_currency: currencyConversionFactor.code,
            is_Bento_User: 'yes',
            utm_source: meta?.utmSource || urlParam.utm_source || 'organic',
            tk_home_abcookie: tk_home_abcookie,
            tk_itin_abcookie: tk_itin_abcookie,
            ...additionpayload
        }
        if (initialTS) {
            clevertapAirPayload.page_load_time = new Date().getTime() - initialTS || 'N/A'
        }
        let fullPayload = {
            ...clevertapData,
            ...clevertapAirPayload
        }
        let chargedPayload = {
            Curerncy: currencyConversionFactor.code,
            product: 'AIR',

            journey_type: multiCity ? 'MultiCity' : arrivalDate ? 'RoundTrip' : 'OneWay',
            dom_intl: international ? 'International' : 'Domestic',
            origin: from,
            destination: to,
            airline: airlineValue,
            pax_count: adults + children + infants,
            source: 'web',
            'date of journey': getFormattedDate(departDate, 'DD/MM/YYYY', 'YYYY-MM-DDTHH:mm:ssZ'),
            'date of return ': arrivalDate ? getFormattedDate(arrivalDate, 'DD/MM/YYYY', 'YYYY-MM-DDTHH:mm:ssZ') : 'NA',
            domain: window.location.host,
            language: window.location.href.includes('/ar/') ? 'ar' : 'en',
            is_Bento_User: 'yes',
            dx: dayDiff(new Date(departDate), new Date()),
            ...additionpayload
        }
        if (eventName === 'Charged') {
            Clevertap.event(eventName, chargedPayload)
        } else {
            if (eventName === 'Air_UI_Action') {
                Clevertap.event(eventName, fullPayload)
            } else if (eventName === 'Air_Failures') {
                Clevertap.event(eventName, fullPayload)
            } else {
                Clevertap.event('Air_PageLoad', fullPayload)
            }
        }
    }
}

export const sendClevertapUIActionEvent = (actionName, actionType = 'BUTTON') => {

    const ctAb = isEmpty(getCookie('ct-ab')) ? {} : JSON.parse(decodeURIComponent(getCookie('ct-ab')))
    const tk_home_abcookie = ctAb['tk_home']
    const tk_itin_abcookie = ctAb['tk_itin']
    if (actionName === 'trv_make_payment_clicked') {
        let fullPayload = {
            action_name: actionName,
            action_type: actionType,
            tk_home_abcookie: tk_home_abcookie,
            tk_itin_abcookie: tk_itin_abcookie
        }
        Clevertap.event('Air_UI_Action', fullPayload)
    }
    else {
        let fullPayload = {
            action_name: actionName,
            action_type: actionType,
        }
        Clevertap.event('Air_UI_Action', fullPayload)
    }

}

export const sendClevertapUIActionEventWithAdditionalData = ({
    actionName = '',
    actionType = 'BUTTON',
    additionalData = {},
    eventName = 'Air_UI_Action',
    itineraryData = {}
}) => {
    let commonData = {}
    if (!isEmpty(itineraryData)) {
        const flights = itineraryData.flights
        const { searchCriteria } = itineraryData
        const { departDate, arrivalDate, international, from, to, multiCity } = searchCriteria || {}
        const airline = []
        flights.forEach(flight => flight.segments.forEach(segment => airline.push(segment.airline)))
        let airlineValue = airline[0]
        if (airline.length > 1) {
            airlineValue = airline[0] + ',' + airline[1]
        }
        commonData = {
            domain: window.location.host,
            origin: from,
            destination: to,
            journey_type: multiCity ? 'MultiCity' : arrivalDate ? 'RoundTrip' : 'OneWay',
            source: 'web',
            platform: 'desktop',
            dom_intl: international ? 'international' : 'Domestic',
            airline: airlineValue,
            departure_date: getFormattedDate(departDate, 'DD/MM/YYYY', 'YYYY-MM-DDTHH:mm:ssZ')
        }
    }
    let fullPayload = {
        action_name: actionName,
        action_type: actionType,
        ...additionalData,
        ...commonData
    }

    Clevertap.event(eventName, fullPayload)
}
export const sendClevertapItinInfoEvent = ({ getItinearyData, ...additionalData }) => {
    const { itineraryId } = getItinearyData
    let payload = {
        source: 'web',
        itineraryId,
        ...additionalData
    }
    Clevertap.event('Air_itin_info', payload)
}
